import { makeStyles } from "@saleor/macaw-ui";

export const useStyles = makeStyles(
  theme => ({
    root: {
      overflowX: "auto",
      width: "100%",
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: 6
    },
    tableProduct: {
      marginTop: 30,
      paddingBottom: "100px"
    },
    mainTable: {
      borderCollapse: "collapse",
      "& .MuiTableCell-head > div > div": {
        color: theme.palette.grey[600]
      },
      "& .MuiFormControl-root": {
        height: 34
      }
    },
    tableTitle: {
      marginTop: 55,
      marginBottom: 20,
      display: "flex",
      alignItems: "center",
      height: 50
    },
    btnDelete: {
      marginLeft: "auto",
      fontSize: 14
    },

    cellBackground: {
      "&&&": {
        background: theme.palette.grey[200],
        color: theme.palette.grey[600]
      },
      "& .MuiSvgIcon-root": {
        color: theme.palette.success.light
      }
    },
    tableRow: {
      borderTop: "2px solid white"
    },
    table: {
      borderCollapse: "collapse"
    },
    customerName: {
      color: theme.palette.grey[900]
    },
    colNumber: {
      color: theme.palette.grey[900]
    },
    colProductName: {
      color: theme.palette.grey[900]
    },
    name: {
      color: theme.palette.grey[900],
      fontWeight: "bold"
    },
    subtitle: {
      fontWeight: 400
    },
    paginationWrapper: {
      marginTop: 16
    },
    snackHeadTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      columnGap: "1.2rem"
    },
    backDrop: {
      zIndex: 1399
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5
    }
  }),
  { name: "CartDetailTable" }
);
